// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tc-2";
export var chatLink = "_tc-0";
export var chatText = "_tc-1";